module.exports = __webpack_public_path__ + "static/assets/e9e97d44300b863ecf49440de27a407d.svg";